import { Input } from "@/components/ui/input";

interface PortfolioSizeInputProps {
  inputValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
}

const PortfolioSizeInput = ({ inputValue, onChange, onBlur }: PortfolioSizeInputProps) => {
  return (
    <Input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      value={inputValue}
      onChange={onChange}
      onBlur={onBlur}
      className="max-w-md [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
    />
  );
};

export default PortfolioSizeInput;